<template>
  <div
    id="pageRoot"
    class="backgroundDeaf"
    style="background-color: var(--book-background-color)"
  >
    <img id="bg" class="pageElement" src="/pages/img/intro/svg05bg.svg" />
    <img
      id="family"
      class="pageElement"
      src="/pages/img/intro/svg05Family.svg"
    />

    <div
      class="pageElement text-box-a hover-animation-a"
      id="globe01"
      style="background-image: url(/pages/img/intro/svg05Globe01.svg)"
    >
      <p class="textBase" id="textBox01Text">
        AQUÍ ESTOY<br />
        CON MI FAMILIA
      </p>
    </div>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 81px;
  top: 185px;
  z-index: 0;
}
#family {
  position: absolute;
  left: 183px;
  top: 352px;
  z-index: 1;
}
#globe01 {
  position: absolute;
  width: 338px;
  height: 170px;
  left: 236px;
  top: 145px;
  z-index: 1;
}
#textBox01Text {
  position: absolute;
  width: 385px;
  left: -30px;
  top: 25px;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  color: #fbf8f8;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p7/V6.mp4"]
    };
  },
};
</script>